export const getMartinboroughData = () => ({
  name: "Martinborough",
  region: "Wairarapa",
  country: "Nouvelle-Zélande",
  description: "Martinborough est le cœur viticole de Wairarapa, réputé pour ses vins de Pinot Noir élégants et ses vins blancs aromatiques. Cette sous-région bénéficie d'un climat maritime unique avec des sols calcaires, créant des conditions idéales pour la viticulture de qualité.",
  type: "subregion",
  area: "600 ha",
  production: "0.05 million hectolitres",
  climate: "Climat maritime avec influences océaniques, étés chauds et hivers doux",
  soil: "Sols calcaires, excellente drainage, faible fertilité",
  characteristics: {
    climate: "Climat maritime avec influences océaniques, étés chauds et hivers doux",
    soil: "Sols calcaires, excellente drainage, faible fertilité",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Pinot Noir élégant avec tanins fins, notes de fruits rouges et épices",
    white: "Vins blancs secs et aromatiques, avec une belle acidité",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif"
  },
  history: "La viticulture à Martinborough a commencé dans les années 1980 avec les premiers vignobles commerciaux. Le Pinot Noir est rapidement devenu le cépage emblématique de la zone, produisant des vins avec une personnalité unique grâce au climat maritime et aux sols calcaires. Aujourd'hui, Martinborough est reconnu comme l'un des meilleurs terroirs de Wairarapa.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, plats locaux, cuisine fusion",
  grapeVarieties: [
    {
      name: "Pinot Noir",
      percentage: "60%",
      description: "Cépage emblématique de Martinborough, produisant des vins élégants avec des tanins fins",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Chardonnay",
      percentage: "20%",
      description: "Cépage blanc principal, produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "15%",
      description: "Cépage blanc produisant des vins frais et aromatiques",
      characteristics: "Frais, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Pinot Gris",
      percentage: "5%",
      description: "Cépage blanc produisant des vins aromatiques et texturés",
      characteristics: "Aromatique, texturé, notes d'épices",
      wineStyles: "Sec à demi-sec, aromatique"
    }
  ],
  statistics: {
    totalArea: "600 ha",
    production: "0.05 million hectolitres",
    wineries: "20+ domaines",
    exportPercentage: "40%"
  },
  viticulture: "La viticulture à Martinborough se caractérise par l'attention aux détails et la recherche de la qualité. Les rendements sont limités pour préserver l'intensité aromatique et la concentration. La viticulture traditionnelle et les vendanges manuelles sont courantes.",
  winemaking: "La vinification se fait principalement en fûts de chêne pour ajouter de la complexité. La macération pré-fermentaire et l'élevage en barriques sont courants. La fermentation malolactique est souvent pratiquée pour adoucir l'acidité.",
  terroir: "Martinborough est caractérisé par ses sols calcaires et son climat maritime. Les sols offrent un excellent drainage et une faible fertilité, forçant les vignes à développer des racines profondes. Le climat maritime apporte des influences océaniques qui modèrent les températures.",
  mapAreas: [
    { region: "Martinborough", x: 175.5, y: -41.0, color: "#4B164C", size: 4 }
  ]
}); 